module.exports = __webpack_public_path__ + "img/forge-icon-black.70248d73.svg";